import React from "react"
import { createBrowserRouter } from "react-router-dom"

import ProtectedRoutes from "app/guards/ProtectedRoutes"
import SuperadminProtectedRoute from "app/guards/SuperadminProtectedRoute"
import { ROUTE_PATTERNS } from "constants/routes"
import Main from "app/layout/Main.component"
import Home from "routes/Home"
import Login from "routes/Login"
import ProjectDetails from "routes/Home/$id"
import Dashboard from "routes/Dashboards/$projectId/$name"
import Tables from "routes/Tables/$projectId/$name"
import Automation from "routes/Automation"
import Docs from "routes/Docs"

/**
 * The application route tree: public login, then the authenticated shell
 * (ProtectedRoutes → Main layout) wrapping the feature pages.
 */
export const router = createBrowserRouter([
  {
    element: <ProtectedRoutes />,
    children: [
      {
        element: <Main />,
        children: [
          {
            path: ROUTE_PATTERNS.HOME,
            element: <Home />,
          },
          {
            path: ROUTE_PATTERNS.PROJECT,
            element: <ProjectDetails />,
          },
          {
            path: ROUTE_PATTERNS.DASHBOARD,
            element: <Dashboard />,
          },
          {
            path: ROUTE_PATTERNS.TAB_SPEC,
            element: <Tables />,
          },
          {
            path: ROUTE_PATTERNS.SUPERADMIN,
            element: <SuperadminProtectedRoute />,
          },
          {
            path: ROUTE_PATTERNS.AUTOMATION,
            element: <Automation />,
          },
          {
            path: ROUTE_PATTERNS.DOCS,
            element: <Docs />,
          },
        ],
      },
    ],
  },
  {
    path: ROUTE_PATTERNS.LOGIN,
    element: <Login />,
  },
])
